// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1opsM","approved":"Status_approved__3Tmgm","rejected":"Status_rejected__3It0t","expired":"Status_expired__3pTHb","label":"Status_label__3JMEH"};